'use client';

import { Suspense, type ReactNode } from 'react';

/** A lazy inspector must not hide the route that owns its return-focus target. */
export function CourseDetailsLoadingBoundary({ children }: { children: ReactNode }) {
  return <Suspense fallback={<p role="status" aria-label="Course details loading" className="mb-3 text-sm text-content-muted">Loading course details…</p>}>
    {children}
  </Suspense>;
}
